// Leaf module: only primitive constants, no imports.
// Kept free of dependencies so `shared/thirdParty/index.ts` can read these
// without pulling in the heavy `./fivetran` barrel (which imports
// `shared/api/credentials` -> `src/dataSource/types` -> back to
// `shared/thirdParty`). That cycle caused a temporal-dead-zone crash on
// `THIRD_PARTY_PROVIDER` during module init on the /thirdParty/callback page.
export const FIVETRAN = 'fivetran'

export const reFivetranId = /^([a-z]+)_([a-z]+)$/
